import axios from 'axios';
import {url} from './util';

export enum Endpoints {
  CHANNEL = 'public/channels/{key}',
  CUSTOMER = 'customer',
  FORGOTTEN_PASSWORD = 'customer/password/remind',
  PASSWORD_RESET = 'customer/password/reset',
  UPDATE_CUSTOMER_DETAILS = 'customer/update-details',
  CONTENT_LIST = 'public/contents',
  PUBLIC_LIST = 'public/list',
  POLICY_APPLICATIONS = 'public/applications',
  POLICY_APPLICATION = 'public/applications/{id}',
  POLICY_APPLICATION_ISSUE = 'public/applications/{id}:issue',
  POLICY_APPLICATION_PAY = 'public/applications/{id}:pay',
  POLICY_APPLICATION_STATUS = 'public/applications/{id}:status',
  POLICY_DOCUMENTS_POLL = 'public/policy:documents-poll',
  DESTINATIONS = 'public/product-destinations',
  STATES = 'public/country-states?filter[country]=AU',
  INDUSTRIES = 'public/product-industries',
  OCCUPATIONS = 'public/product-occupations',
  POSTCODE_LOOKUP = 'public/postcode/{postcode}',
  POSTCODE_GET = 'public/address/{id}',
  TRANSACTION_PAY = 'public/transactions/{id}:redirect',
  CAMPAIGN_CODE = '/public/campaigns/code/{code}',
  REFERRAL_QUOTE = 'public/applications/{id}:refer',
  PREMIUMS_BY_PAYMENT_SCHEDULES = 'public/premium-groups',
  CHECK_EXISTING_CUSTOMER = 'public/customers/exists',
  VEHICLE_LOOKUP = 'dvla/search/{registration}',
  VEHICLE_EXCESSES = 'agriculture-schemes/{scheme}:vehicle-excesses',
  COMPULSORY_POLICY_EXCESS = 'agriculture-schemes/{scheme}:compulsory-policy-excess',
  ENRICHMENT_CHECK = 'agriculture-schemes/enrichment-check',
}
export function documentsPoll(documentsPollToken: string) {
  return axios
    .post(
      url(Endpoints.POLICY_DOCUMENTS_POLL),
      { documentsPollToken },
      { headers: { 'Content-Type': 'application/vnd.api+json' }},
    )
    .then((response) => {
      return response.data;
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/endpoints.ts